export const dealLabel = "Deal";
export const addDealLabel = "Add Deal";
export const companyLabel = "Company Name";
export const contactNameLabel = "Contact Name";
export const dealTypeLabel = "Deal Type";
export const dealStatusLabel = "Deal Status";
export const closedDate = "Closed Date";
export const addedByLabel = "Added By";
export const dealDescription = "Deal Description";
export const dealRemark = "Deal Remarks";
export const editDeal = "Edit Deal";
export const ACCESSOR_KEYS = {
  SRNOLABEL: "Sr no.",
  SERIAL_NUMBER: "serial_number",
  COMPANY: "company_name",
  CONTACT_NAME: "contact_name",
  DEAL_TYPE: "deal_type",
  CLOSED_DATE: "closed_date",
  DEAL_STATUS: "deal_status",
  ADDED_BY: "name",
  ACTION: "action",
  DEAL_DESCRIPTION: "deal_description",
};

export const DEAL_STATUS_BADGE_MAP = {
  Active: "primary",
  "On Hold": "secondary",
  "At Risk": "warning",
  Completed: "success",
  Closed: "danger",
};

export const DeleteDealConfirm = "Are you sure you want to delete this deal?";
